import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { LeadProvider } from "@/components/site/LeadContext";
import Landing from "@/pages/Landing";
import Obrigado from "@/pages/Obrigado";
import ObrigadoMergulho from "@/pages/ObrigadoMergulho";
import DadosDM from "@/pages/DadosDM";
import Quiz from "@/pages/Quiz";
import DadosAbrolhos from "@/pages/DadosAbrolhos";
import DadosAbrolhosAdmin from "@/pages/DadosAbrolhosAdmin";
import ClubeDiveMaster from "@/pages/ClubeDiveMaster";
import ParticiparDoClube from "@/pages/ParticiparDoClube";

function App() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.1,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    let rafId;
    function raf(time) {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    }
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App">
      <LeadProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/quiz" element={<Quiz />} />
            <Route path="/obrigado" element={<ObrigadoMergulho />} />
            <Route path="/obrigado-clube" element={<Obrigado />} />
            <Route path="/dadosdm2026" element={<DadosDM />} />
            <Route path="/dadosabrolhos" element={<DadosAbrolhos />} />
            <Route path="/dadosabrolhosdm" element={<DadosAbrolhosAdmin />} />
            <Route path="/clubedivemaster" element={<ClubeDiveMaster />} />
            <Route path="/participardoclube" element={<ParticiparDoClube />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </LeadProvider>
    </div>
  );
}

export default App;
